import { Navigate, useLocation, useParams } from "react-router-dom";
import { urls } from "../../../../urls";
import { EditBasicSourcingEvent } from "./EditBasicSourcingEvent";

export const EditBseEditRoute = () => {
  const { eventId } = useParams();
  const location = useLocation();

  if (eventId) {
    return <Navigate to={`${urls.v2.sourcingEvents.bseEdit.go(eventId)}${location.search}${location.hash}`} replace />;
  }

  return <EditBasicSourcingEvent />;
};
